import { useState } from "react";
import {
  Avatar,
  CardHeader,
  Box,
  Typography,
  Modal,
  makeStyles,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  headerInfo: {
    cursor: "pointer",
    [theme.breakpoints.down("959")]: {
      width: "fit-content",
      display: "inline-flex",
    },
    [theme.breakpoints.down("500")]: {
      width: "60vw",
    },
    [theme.breakpoints.down("400")]: {
      width: "50vw",
    },
    "& span": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  content: {
    width: "100%",
    display: "grid",
  },
  subheader: {
    fontSize: ".85rem",
    paddingTop: "5px",
    "& span": {
      fontSize: ".85rem",
      padding: "0",
      margin: "0",
    },
  },
  signedTo: {
    position: "relative",
    display: "block",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalImage: {
    maxWidth: "90%",
    maxHeight: "90%",
    borderRadius: "8px",
    boxShadow: theme.shadows[5],
  },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const profilePicUrl =
    (contact?.isGroup
      ? ticket?.GroupInformations?.profilePictureUrl ||
        ticket?.GroupInformations?.contactPictureUrl
      : null) ||
    contact?.profilePicUrl;
  const hasProfilePic = Boolean(profilePicUrl);

  const handleAvatarClick = (e) => {
    e.stopPropagation();
    if (!hasProfilePic) return;
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <CardHeader
        onClick={onClick}
        className={classes.headerInfo}
        titleTypographyProps={{ noWrap: true }}
        subheaderTypographyProps={{ noWrap: true }}
        avatar={
          <Avatar
            src={hasProfilePic ? profilePicUrl : undefined}
            alt="contact_image"
            onClick={handleAvatarClick}
            style={{ cursor: hasProfilePic ? "zoom-in" : "default" }}
          />
        }
        title={`${contact.isGroup ? i18n.t("groupPrefix") : ""}${contact.name} #${ticket.id}`}
        subheader={
          <Box className={classes.subheader}>
            {ticket.Queue && `Fila: ${ticket.Queue.name}`}
            {ticket.User && (
              <Typography component="span" className={classes.signedTo}>
                {`${i18n.t("messagesList.header.assignedTo")} ${ticket.User.name}`}
              </Typography>
            )}
          </Box>
        }
        classes={{
          content: classes.content,
        }}
      />

      {/* Modal da imagem ampliada */}
      <Modal open={open} onClose={handleClose} className={classes.modal}>
        <img
          src={profilePicUrl}
          alt="contact_image_large"
          className={classes.modalImage}
          onClick={handleClose}
        />
      </Modal>
    </>
  );
};

export default TicketInfo;
